import React from "react";
import { CustomMaterialTable, Loading } from "components";

export const ReferencesTable = ({
  referencesData,
  columns,
  isLoading,
}: {
  referencesData: any;
  columns: any;
  isLoading?: boolean;
}) => (
  <div>
    {isLoading ? (
      <Loading />
    ) : (
      <CustomMaterialTable
        columns={columns}
        data={referencesData}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableGlobalFilter={false}
        enableColumnResizing
        initialState={{ density: "compact" }}
        enablePagination={false}
        containerSx={{
          height: "calc(100vh - 240px)",
          maxWidth: "calc(100vw - 151px)",
        }}
      />
    )}
  </div>
);
